export default __webpack_public_path__ + "static/media/bg_help1.28b43f32.png";